import { useState, useEffect } from 'react';

export const useGoogleAnalytics = (measurementId: string) => {
  const [analyticsEnabled, setAnalyticsEnabled] = useState(true);

  useEffect(() => {
    const checkConsent = () => {
      const analyticsConsent = localStorage.getItem('analytics-consent');
      
      // Only disable if user explicitly declined
      if (analyticsConsent === 'declined') {
        setAnalyticsEnabled(false);
      } else {
        setAnalyticsEnabled(true);
      }
    };

    checkConsent();

    const handleConsentAccepted = () => {
      setAnalyticsEnabled(true);
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('consent', 'update', {
          analytics_storage: 'granted',
        });
      }
    };

    const handleConsentDeclined = () => {
      setAnalyticsEnabled(false);
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('consent', 'update', {
          analytics_storage: 'denied',
        });
      }
    };

    window.addEventListener('cookieConsentAccepted', handleConsentAccepted);
    window.addEventListener('cookieConsentDeclined', handleConsentDeclined);

    return () => {
      window.removeEventListener('cookieConsentAccepted', handleConsentAccepted);
      window.removeEventListener('cookieConsentDeclined', handleConsentDeclined);
    };
  }, []);

  return { analyticsEnabled };
};
